// Generated by ts-to-zod
import { z } from 'zod';

const nameSchema = z.object({
  first_name: z.string(),
  formatted_name: z.string(),
});

const phoneSchema = z.object({
  phone: z.string(),
});

const contactSchema = z.object({
  name: nameSchema,
  phones: z.array(phoneSchema),
});

export const contactTemplateSchema = z.object({
  type: z.literal('contacts'),
  contacts: z.array(contactSchema),
});
